import React from "react";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";

const services = [
  {
    icon: "fa-graduation-cap",
    title: "EdTech & LMS",
    desc: "Adaptive learning platforms with auto-grading, AI mocktests, live classes, and chat-with-your-notes — the engine behind ClassScribe.",
    tag: "Live: ClassScribe",
    color: "#2f7df6",
  },
  {
    icon: "fa-heartbeat",
    title: "Healthcare & HMS",
    desc: "End-to-end hospital automation — patient records, smart appointment scheduling, billing, pharmacy, and AI diagnostics assistance.",
    tag: "Live: HMS",
    color: "#0ea5a4",
  },
  {
    icon: "fa-cubes",
    title: "Retail & Distribution ERP",
    desc: "Inventory, POS, purchase and excise-compliant billing with an AI assistant — built for field force and retailers like LiKAR.",
    tag: "Live: LiKAR",
    color: "#10b981",
  },
  {
    icon: "fa-cogs",
    title: "Enterprise ERP",
    desc: "Unified business intelligence connecting HR, inventory, finance, procurement, and operations with predictive forecasting.",
    tag: "On request",
    color: "#8b5cf6",
  },
  {
    icon: "fa-mobile",
    title: "Cross-Platform Apps",
    desc: "Web, mobile, and installable PWA experiences built on modern frameworks — fast, offline-ready, and beautifully designed.",
    tag: "Web · iOS · Android",
    color: "#ec4899",
  },
  {
    icon: "fa-magic",
    title: "Custom AI Software",
    desc: "Have a unique workflow? We design and ship bespoke, AI-powered systems tailored precisely to how your business runs.",
    tag: "Bespoke",
    color: "#22a178",
  },
];

function WWEComponent() {
  return (
    <div className="wwe-section-new" id="services">
      <div className="container">
        <motion.div
          className="wwe-header text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge section-badge-light">Services</div>
          <h3>
            What We <span className="accent-grad">Build</span>
          </h3>
          <p className="wwe-subtitle">
            From intelligent workflow design to robust, AI-powered enterprise
            automation — we turn complex operations into software that works for
            you, not the other way around.
          </p>
        </motion.div>

        <Row className="wwe-grid">
          {services.map((s, i) => (
            <Col xs={12} md={6} lg={4} key={s.title}>
              <motion.div
                className="wwe-card"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                whileHover={{ y: -8, transition: { duration: 0.25 } }}
                style={{ "--card-color": s.color }}
              >
                <div
                  className="wwe-icon-wrap"
                  style={{
                    borderColor: `${s.color}33`,
                    background: `linear-gradient(135deg, ${s.color}1f, ${s.color}0a)`,
                  }}
                >
                  <span className={`fa ${s.icon}`} style={{ color: s.color }}></span>
                </div>
                <h5 className="wwe-card-title">{s.title}</h5>
                <p className="wwe-card-desc">{s.desc}</p>
                <span
                  className="wwe-card-tag"
                  style={{ color: s.color, background: `${s.color}14`, borderColor: `${s.color}33` }}
                >
                  {s.tag}
                </span>
                <div className="wwe-card-accent" style={{ background: s.color }} />
              </motion.div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default WWEComponent;
